import "../../assets/ParticipantList.css";
import { jsx as l, jsxs as g, Fragment as w } from "react/jsx-runtime";
import { $ as ee, f as z, d as P, _ as m, i as te, g as be, a as oe, l as $e } from "../../index-e16aa371.js";
import a, { forwardRef as L, createElement as E, useCallback as ue, useState as me, useRef as N, useEffect as ve, useContext as Ce, createContext as _e } from "react";
import { $ as he } from "../../index-fff30d53.js";
import { $ as ne, T as R } from "../../Tooltip-ea1eb7b8.js";
import { DownArrow as U } from "../icons/DownArrow.js";
import { ParticipantInfo as ge } from "../ParticipantInfo/ParticipantInfo.js";
const re = "Collapsible", [xe, ce] = ee(re), [Ae, G] = xe(re), Ie = /* @__PURE__ */ L((e, r) => {
  const { __scopeCollapsible: t, open: o, defaultOpen: c, disabled: n, onOpenChange: i, ...d } = e, [f = !1, s] = z({
    prop: o,
    defaultProp: c,
    onChange: i
  });
  return /* @__PURE__ */ E(Ae, {
    scope: t,
    disabled: n,
    contentId: ne(),
    open: f,
    onOpenToggle: ue(
      () => s(
        (p) => !p
      ),
      [
        s
      ]
    )
  }, /* @__PURE__ */ E(P.div, m({
    "data-state": K(f),
    "data-disabled": n ? "" : void 0
  }, d, {
    ref: r
  })));
}), Ee = "CollapsibleTrigger", ye = /* @__PURE__ */ L((e, r) => {
  const { __scopeCollapsible: t, ...o } = e, c = G(Ee, t);
  return /* @__PURE__ */ E(P.button, m({
    type: "button",
    "aria-controls": c.contentId,
    "aria-expanded": c.open || !1,
    "data-state": K(c.open),
    "data-disabled": c.disabled ? "" : void 0,
    disabled: c.disabled
  }, o, {
    ref: r,
    onClick: te(e.onClick, c.onOpenToggle)
  }));
}), ae = "CollapsibleContent", we = /* @__PURE__ */ L((e, r) => {
  const { forceMount: t, ...o } = e, c = G(ae, e.__scopeCollapsible);
  return /* @__PURE__ */ E(
    be,
    {
      present: t || c.open
    },
    ({ present: n }) => /* @__PURE__ */ E(Ne, m({}, o, {
      ref: r,
      present: n
    }))
  );
}), Ne = /* @__PURE__ */ L((e, r) => {
  const { __scopeCollapsible: t, present: o, children: c, ...n } = e, i = G(ae, t), [d, f] = me(o), s = N(null), p = oe(r, s), b = N(0), C = b.current, _ = N(0), A = _.current, y = i.open || d, I = N(y), h = N();
  return ve(() => {
    const u = requestAnimationFrame(
      () => I.current = !1
    );
    return () => cancelAnimationFrame(u);
  }, []), $e(() => {
    const u = s.current;
    if (u) {
      h.current = h.current || {
        transitionDuration: u.style.transitionDuration,
        animationName: u.style.animationName
      }, u.style.transitionDuration = "0s", u.style.animationName = "none";
      const v = u.getBoundingClientRect();
      b.current = v.height, _.current = v.width, I.current || (u.style.transitionDuration = h.current.transitionDuration, u.style.animationName = h.current.animationName), f(o);
    }
  }, [
    i.open,
    o
  ]), /* @__PURE__ */ E(P.div, m({
    "data-state": K(i.open),
    "data-disabled": i.disabled ? "" : void 0,
    id: i.contentId,
    hidden: !y
  }, n, {
    ref: p,
    style: {
      "--radix-collapsible-content-height": C ? `${C}px` : void 0,
      "--radix-collapsible-content-width": A ? `${A}px` : void 0,
      ...e.style
    }
  }), y && c);
});
function K(e) {
  return e ? "open" : "closed";
}
const Pe = Ie, Re = ye, Le = we, Oe = /* @__PURE__ */ _e(void 0);
function De(e) {
  const r = Ce(Oe);
  return e || r || "ltr";
}
const x = "Accordion", Se = [
  "Home",
  "End",
  "ArrowDown",
  "ArrowUp",
  "ArrowLeft",
  "ArrowRight"
], [j, Ve, ke] = he(x), [O, bt] = ee(x, [
  ke,
  ce
]), B = ce(), ie = /* @__PURE__ */ a.forwardRef((e, r) => {
  const { type: t, ...o } = e, c = o, n = o;
  return /* @__PURE__ */ a.createElement(j.Provider, {
    scope: e.__scopeAccordion
  }, t === "multiple" ? /* @__PURE__ */ a.createElement(Fe, m({}, n, {
    ref: r
  })) : /* @__PURE__ */ a.createElement(He, m({}, c, {
    ref: r
  })));
});
ie.propTypes = {
  type(e) {
    const r = e.value || e.defaultValue;
    return e.type && ![
      "single",
      "multiple"
    ].includes(e.type) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected one of `single | multiple`.") : e.type === "multiple" && typeof r == "string" ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `single` when `defaultValue` or `value` is type `string`.") : e.type === "single" && Array.isArray(r) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `multiple` when `defaultValue` or `value` is type `string[]`.") : null;
  }
};
const [se, Te] = O(x), [le, Me] = O(x, {
  collapsible: !1
}), He = /* @__PURE__ */ a.forwardRef((e, r) => {
  const { value: t, defaultValue: o, onValueChange: c = () => {
  }, collapsible: n = !1, ...i } = e, [d, f] = z({
    prop: t,
    defaultProp: o,
    onChange: c
  });
  return /* @__PURE__ */ a.createElement(se, {
    scope: e.__scopeAccordion,
    value: d ? [
      d
    ] : [],
    onItemOpen: f,
    onItemClose: a.useCallback(
      () => n && f(""),
      [
        n,
        f
      ]
    )
  }, /* @__PURE__ */ a.createElement(le, {
    scope: e.__scopeAccordion,
    collapsible: n
  }, /* @__PURE__ */ a.createElement(de, m({}, i, {
    ref: r
  }))));
}), Fe = /* @__PURE__ */ a.forwardRef((e, r) => {
  const { value: t, defaultValue: o, onValueChange: c = () => {
  }, ...n } = e, [i = [], d] = z({
    prop: t,
    defaultProp: o,
    onChange: c
  }), f = a.useCallback(
    (p) => d(
      (b = []) => [
        ...b,
        p
      ]
    ),
    [
      d
    ]
  ), s = a.useCallback(
    (p) => d(
      (b = []) => b.filter(
        (C) => C !== p
      )
    ),
    [
      d
    ]
  );
  return /* @__PURE__ */ a.createElement(se, {
    scope: e.__scopeAccordion,
    value: i,
    onItemOpen: f,
    onItemClose: s
  }, /* @__PURE__ */ a.createElement(le, {
    scope: e.__scopeAccordion,
    collapsible: !0
  }, /* @__PURE__ */ a.createElement(de, m({}, n, {
    ref: r
  }))));
}), [ze, D] = O(x), de = /* @__PURE__ */ a.forwardRef((e, r) => {
  const { __scopeAccordion: t, disabled: o, dir: c, orientation: n = "vertical", ...i } = e, d = a.useRef(null), f = oe(d, r), s = Ve(t), b = De(c) === "ltr", C = te(e.onKeyDown, (_) => {
    var A;
    if (!Se.includes(_.key))
      return;
    const y = _.target, I = s().filter((M) => {
      var H;
      return !((H = M.ref.current) !== null && H !== void 0 && H.disabled);
    }), h = I.findIndex(
      (M) => M.ref.current === y
    ), u = I.length;
    if (h === -1)
      return;
    _.preventDefault();
    let v = h;
    const S = 0, V = u - 1, k = () => {
      v = h + 1, v > V && (v = S);
    }, T = () => {
      v = h - 1, v < S && (v = V);
    };
    switch (_.key) {
      case "Home":
        v = S;
        break;
      case "End":
        v = V;
        break;
      case "ArrowRight":
        n === "horizontal" && (b ? k() : T());
        break;
      case "ArrowDown":
        n === "vertical" && k();
        break;
      case "ArrowLeft":
        n === "horizontal" && (b ? T() : k());
        break;
      case "ArrowUp":
        n === "vertical" && T();
        break;
    }
    const pe = v % u;
    (A = I[pe].ref.current) === null || A === void 0 || A.focus();
  });
  return /* @__PURE__ */ a.createElement(ze, {
    scope: t,
    disabled: o,
    direction: c,
    orientation: n
  }, /* @__PURE__ */ a.createElement(j.Slot, {
    scope: t
  }, /* @__PURE__ */ a.createElement(P.div, m({}, i, {
    "data-orientation": n,
    ref: f,
    onKeyDown: o ? void 0 : C
  }))));
}), F = "AccordionItem", [Ge, q] = O(F), Ke = /* @__PURE__ */ a.forwardRef((e, r) => {
  const { __scopeAccordion: t, value: o, ...c } = e, n = D(F, t), i = Te(F, t), d = B(t), f = ne(), s = o && i.value.includes(o) || !1, p = n.disabled || e.disabled;
  return /* @__PURE__ */ a.createElement(Ge, {
    scope: t,
    open: s,
    disabled: p,
    triggerId: f
  }, /* @__PURE__ */ a.createElement(Pe, m({
    "data-orientation": n.orientation,
    "data-state": fe(s)
  }, d, c, {
    ref: r,
    disabled: p,
    open: s,
    onOpenChange: (b) => {
      b ? i.onItemOpen(o) : i.onItemClose(o);
    }
  })));
}), je = "AccordionHeader", Be = /* @__PURE__ */ a.forwardRef((e, r) => {
  const { __scopeAccordion: t, ...o } = e, c = D(x, t), n = q(je, t);
  return /* @__PURE__ */ a.createElement(P.h3, m({
    "data-orientation": c.orientation,
    "data-state": fe(n.open),
    "data-disabled": n.disabled ? "" : void 0
  }, o, {
    ref: r
  }));
}), Y = "AccordionTrigger", qe = /* @__PURE__ */ a.forwardRef((e, r) => {
  const { __scopeAccordion: t, ...o } = e, c = D(x, t), n = q(Y, t), i = Me(Y, t), d = B(t);
  return /* @__PURE__ */ a.createElement(j.ItemSlot, {
    scope: t
  }, /* @__PURE__ */ a.createElement(Re, m({
    "aria-disabled": n.open && !i.collapsible || void 0,
    "data-orientation": c.orientation,
    id: n.triggerId
  }, d, o, {
    ref: r
  })));
}), Ue = "AccordionContent", Ye = /* @__PURE__ */ a.forwardRef((e, r) => {
  const { __scopeAccordion: t, ...o } = e, c = D(x, t), n = q(Ue, t), i = B(t);
  return /* @__PURE__ */ a.createElement(Le, m({
    role: "region",
    "aria-labelledby": n.triggerId,
    "data-orientation": c.orientation
  }, i, o, {
    ref: r,
    style: {
      "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
      "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
      ...e.style
    }
  }));
});
function fe(e) {
  return e ? "open" : "closed";
}
const Je = ie, J = Ke, Q = Be, W = qe, X = Ye, Qe = "_participantLists_dnv3e_1", We = "_accordionHeader_dnv3e_1", Xe = "_accordionTrigger_dnv3e_5", Ze = "_accordionLabel_dnv3e_18", et = "_accordionChevron_dnv3e_22", tt = "_accordionContent_dnv3e_28", ot = "_participantList_dnv3e_1", nt = "_participantListItem_dnv3e_58", $ = {
  participantLists: Qe,
  accordionHeader: We,
  accordionTrigger: Xe,
  accordionLabel: Ze,
  accordionChevron: et,
  accordionContent: tt,
  "slide-down": "_slide-down_dnv3e_1",
  "slide-up": "_slide-up_dnv3e_1",
  participantList: ot,
  participantListItem: nt
}, rt = (e, r) => r === e, Z = ({
  participant: e,
  goToMessages: r,
  activeUuid: t,
  messageThread: o,
  lastNameFirst: c = !1
}) => /* @__PURE__ */ l("li", { className: $.participantListItem, children: /* @__PURE__ */ l(
  "div",
  {
    role: "button",
    onClick: () => {
      r({
        messageThread: o,
        participantUuid: e.uuid
      });
    },
    children: /* @__PURE__ */ l(
      ge,
      {
        ...e,
        format: "horizontal",
        size: "medium",
        selected: rt(e.uuid, t),
        count: (o == null ? void 0 : o.unreadCount) || 0,
        lastNameFirst: c
      }
    )
  }
) }), $t = ({
  participants: e,
  inactiveParticipants: r,
  activeUuid: t,
  messageThreads: o,
  goToMessages: c,
  isPatientUi: n = !1,
  currentMessageThreadUuid: i,
  expandInactive: d = !1
}) => {
  const f = ["participant-list-active"];
  return d && f.push("participant-list-inactive"), /* @__PURE__ */ l("div", { className: $.participantLists, children: /* @__PURE__ */ g(Je, { type: "multiple", defaultValue: f, children: [
    /* @__PURE__ */ g(J, { value: "participant-list-active", children: [
      /* @__PURE__ */ l(Q, { className: $.accordionHeader, children: /* @__PURE__ */ g(W, { className: $.accordionTrigger, children: [
        /* @__PURE__ */ l("div", { className: $.accordionLabel, children: n ? /* @__PURE__ */ g(w, { children: [
          "Care team",
          /* @__PURE__ */ l(R, { text: "Providers on your care team and those you ended care with in the last 14 days" })
        ] }) : /* @__PURE__ */ g(w, { children: [
          "Current clients",
          /* @__PURE__ */ l(R, { text: "Clients you've seen, have recently scheduled with, or ended care in the last 14 days." })
        ] }) }),
        /* @__PURE__ */ l(
          U,
          {
            width: 14,
            height: 8,
            className: $.accordionChevron
          }
        )
      ] }) }),
      /* @__PURE__ */ l(X, { className: $.accordionContent, children: /* @__PURE__ */ l("ul", { className: $.participantList, children: e.map((s) => {
        const p = o.find(
          ({ patientUuid: b, providerUuid: C }) => (n ? C : b) === s.uuid
        );
        return /* @__PURE__ */ l(
          Z,
          {
            participant: s,
            goToMessages: c,
            messageThread: p,
            activeUuid: t,
            currentMessageThreadUuid: i,
            lastNameFirst: !n
          },
          s.uuid
        );
      }) }) })
    ] }),
    r && r.length ? /* @__PURE__ */ g(J, { value: "participant-list-inactive", children: [
      /* @__PURE__ */ l(Q, { className: $.accordionHeader, children: /* @__PURE__ */ g(W, { className: $.accordionTrigger, children: [
        /* @__PURE__ */ l("div", { className: $.accordionLabel, children: n ? /* @__PURE__ */ g(w, { children: [
          "Past providers",
          /* @__PURE__ */ l(R, { text: "Conversations with providers who are no longer delivering you care" })
        ] }) : /* @__PURE__ */ g(w, { children: [
          "Past clients",
          /* @__PURE__ */ l(R, { text: "Previous messages from clients you are no longer providing care to." })
        ] }) }),
        /* @__PURE__ */ l(
          U,
          {
            width: 14,
            height: 8,
            className: $.accordionChevron
          }
        )
      ] }) }),
      /* @__PURE__ */ l(X, { className: $.accordionContent, children: /* @__PURE__ */ l("ul", { className: $.participantList, children: r.map((s) => {
        const p = o.find(
          ({ patientUuid: b, providerUuid: C }) => (n ? C : b) === s.uuid
        );
        return /* @__PURE__ */ l(
          Z,
          {
            participant: s,
            goToMessages: c,
            messageThread: p,
            activeUuid: t,
            currentMessageThreadUuid: i
          },
          s.uuid
        );
      }) }) })
    ] }) : /* @__PURE__ */ l(w, {})
  ] }) });
};
export {
  $t as ParticipantList
};
